/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import _ from 'lodash';

import { manuFactureHead } from '../../../../SharedModules/Table/tableHead';
import {
  getRebateProgramCode,
  setReqURACalcData,
  getManufacturersByPQR,
  calculateURA,
  getMaxQuarterForFreezeDt,
  dispatchCalculateInvoice,
  setErrorMessagesData,
  dispatchManufacturersByPQR,
} from '../Store/actions';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import {
  checkQuarterValidation,
  quarterFormatter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

function RequestURACalculation() {
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [runNow, setRunNow] = useState('');
  const [selected, setSelected] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const reqURACalcData = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.reqURACalcData
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.errorMessages
  );
  const rebateProgramCodeURA = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.rebateProgramCode
  );
  const manufacturersByPQR = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.manufacturersByPQR
  );

  const calculateURAData = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.calculateURA
  );
  const defaultQtrURA = useSelector(
    (state) => state.sharedState.ReqURACalcReducer?.defaultQtrURA?.data
  );

  // const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));

  const UserDefaultValues = useSelector(
    (state) => state.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getRebateProgramCodeValue = (values) => {
    const payload = {
      planTypeCd: values,
    };
    dispatch(getRebateProgramCode(payload));
  };

  const onCellClicked = (e) => {
    setErrorMessages([]);
    setSuccessMessages([])
    setSelected(e.data.mfgId);
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/RequestURACalculation', true);
    } else {
      tabHighLigther('/RequestURACalculation', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  useEffect(() => {}, [manufacturersByPQR]);

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  
  // const initializedRef = React.useRef(false);
  
  useEffect(() => {
    if (reqURACalcData?.planType) {
      getRebateProgramCodeValue(reqURACalcData?.planType);
    }
  }, [UserDefaultValues?.planTypeCd, reqURACalcData?.planType]);
  
  useEffect(() => {
    if (
      reqURACalcData?.planType &&
      reqURACalcData?.rebateProgramCode &&
      reqURACalcData?.quarter
    ) {
      setSelected(null);
      searchManufacturers();
    }
  }, [
    reqURACalcData?.planType,
    reqURACalcData?.rebateProgramCode,
    reqURACalcData?.quarter,
  ]);

  useEffect(() => {
    if (defaultQtrURA) {
      dispatch(
        setReqURACalcData({
          ...reqURACalcData,
          quarter: !reqURACalcData?.quarter
            ? defaultQtrURA
            : reqURACalcData?.quarter,
          // planType:
          //   reqURACalcData?.planType === ''
          //     ? UserDefaultValues?.planTypeCd
          //     : reqURACalcData?.planType,
          // rebateProgramCode:
          //   reqURACalcData?.rebateProgramCode === ''
          //     ? UserDefaultValues?.rebateProgramCd
          //     : reqURACalcData?.rebateProgramCode,
        })
      );
    }
  }, [defaultQtrURA]);

  useEffect(() => {
    dispatch(getMaxQuarterForFreezeDt());
    if (!UserDefaultValues) return;
 
    let updatedRebateProgramCode;
    const userRebateCode = UserDefaultValues?.rebateProgramCd;
    const isFD = UserDefaultValues?.planTypeCd === 'FD';
    
    const updatedPlanType =
      reqURACalcData?.planType && reqURACalcData?.planType !== ''
        ? reqURACalcData.planType
        : isFD
        ? 'COMM'
        : UserDefaultValues?.planTypeCd ?? 'COMM';
    
    if (isFD) {
      updatedRebateProgramCode =
        rebateProgramCodeURA?.length > 0 ? rebateProgramCodeURA[0].rpc : '-1';
    } else {
      if( rebateProgramCodeURA?.length > 0 && userRebateCode !== "-1") {
        let match_found = false;
        for (let i=0;i<rebateProgramCodeURA?.length;i++) {
          if (rebateProgramCodeURA[i].rpc === userRebateCode) {
            match_found = true;
            break;
          }
        }
        updatedRebateProgramCode = match_found ? userRebateCode : rebateProgramCodeURA[0].rpc;
      } else {
        updatedRebateProgramCode = rebateProgramCodeURA?.length > 0 ? rebateProgramCodeURA[0].rpc : '-1';
      }
    }
    
    // const updatedQuarter =
    //   reqURACalcData?.quarter && reqURACalcData?.quarter !== ''
    //     ? reqURACalcData.quarter
    //     : UserDefaultValues?.quarter ?? defaultQtrURA;
    dispatch(
      setReqURACalcData({
        ...reqURACalcData,
        quarter: defaultQtrURA,
        planType: updatedPlanType,
        rebateProgramCode: updatedRebateProgramCode,
      })
    );

    // initializedRef.current = true;
  }, [UserDefaultValues, rebateProgramCodeURA, defaultQtrURA, dispatch]);

  useEffect(() => {
    // setErrorMessages([]);
    // setSuccessMessages([]);
    if (calculateURAData?.error === 'API failed') {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      // setSuccessMessages([]);
    } else if (calculateURAData && runNow === 'N') {
      setSuccessMessages([CONSTANTS.INVOICE_JOB_COMPLETE]);
      // setErrorMessages([]);
      // setTimeout(() => {
        dispatch(dispatchCalculateInvoice(null));
      // }, 5000);
    } else if (calculateURAData && runNow === 'L') {
      setSuccessMessages([CONSTANTS.INVOICE_JOB_DEFERED]);
      // setErrorMessages([]);
      // setTimeout(() => {
        dispatch(dispatchCalculateInvoice(null));
      // }, 5000);
    } else if (calculateURAData) {
      // dispatch(
      //   setErrorMessagesData([
      //     {
      //       field: 'resultNotFound',
      //       errorType: 'resultNotFound',
      //       message: CONSTANTS.ERR_PROCESSING_REQ,
      //     },
      //   ])
      // );
    } else if (calculateURAData?.error === 'API failed') {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      // setSuccessMessages([]);
    } else if (calculateURAData?.error?.status === '002') {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message:
              calculateURAData?.error?.message || CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      // setSuccessMessages([]);
    }
  }, [calculateURAData, runNow]);

  const handleReqURACalcData = (e) => {
    setErrorMessages([]);
    setSuccessMessages([]);
    if (e.target.name === 'allManufacturers') {
      if (e.target.checked) {
        setSelected(null);
      }
      dispatch(
        setReqURACalcData({
          ...reqURACalcData,
          [e.target.name]: e.target.checked ? 'Yes' : 'No',
        })
      );
    } else if (e.target.name === 'planType') {
      dispatch(
        setReqURACalcData({
          ...reqURACalcData,
          planType: e.target.value,
          rebateProgramCode: '-1'
        })
      );
    }else {
      dispatch(
        setReqURACalcData({
          ...reqURACalcData,
          [e.target.name]: e.target.value,
          ...('planType' in reqURACalcData &&
            e.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
    }
  };
  const validateURACalcReq = () => {
    setErrorMessages([]);
    setSuccessMessages([]);

    let localErr = [];
    if (
      reqURACalcData?.rebateProgramCode === '' ||
      reqURACalcData?.rebateProgramCode === '-1'
    ) {
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCode',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (reqURACalcData?.quarter === '') {
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(reqURACalcData?.quarter)) {
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    dispatch(setErrorMessagesData([...new Set(localErr)]));
    return !localErr.length > 0;
  };

  const searchManufacturers = () => {

    if (validateURACalcReq()) {
      dispatch(getManufacturersByPQR(reqURACalcData));
    }
  };

  const runURACalculation = (e, runFlag) => {
    setSuccessMessages([]);
    setErrorMessages([]);
    setRunNow(runFlag);
    if (validateURACalcReq()) {
      const reqURACalcDataPayload = {
        ...reqURACalcData,
        runProcedure: runFlag,
        manufacturerId:
          reqURACalcData.allManufacturers === 'No' && selected != null
            ? selected
            : null,
      };
      const formattedReq = {
        rpc: reqURACalcDataPayload?.rebateProgramCode,
        qtr: reqURACalcDataPayload?.quarter,
        planTypeCd: reqURACalcDataPayload?.planType,
        userId: logInUser,
        all: reqURACalcDataPayload?.allManufacturers,
        mfg: reqURACalcDataPayload?.manufacturerId,
        runCd: reqURACalcDataPayload?.runProcedure,
      };
      dispatch(dispatchCalculateInvoice(null));
      dispatch(calculateURA(formattedReq));
    }
  };

  const handleFullScreenView = () => {
    setErrorMessages([]);
    setSuccessMessages([])
    setFullScreenView(!fullScreenView);
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    setErrorMessages([]);
    setSuccessMessages([])
    let localErr = errorMessagesFromRedux || [];
    if (type === 'rebateProgramCode') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCode',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
      }
    }

    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );

          dispatch(
            setReqURACalcData({
              ...reqURACalcData,
              quarter: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    if (!localErr?.length > 0) {
      setSelected(null);
      searchManufacturers();
    }
    dispatch(setErrorMessagesData([...new Set(localErr)]));
  };
   const [gridApi, setGridApi] = React.useState(null);
      const onGridReady = (params) => {
        setGridApi(params.api);
      };
      React.useEffect(() => {
        if (!gridApi || manufacturersByPQR?.data === 0) return;
        const selectedRows = gridApi.getSelectedRows();
        if (selectedRows?.length > 0) return;
        const firstNode = gridApi.getDisplayedRowAtIndex(0);
        if (firstNode) {
          firstNode.setSelected(true);
        }
      }, [gridApi, manufacturersByPQR?.data]);
  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space pb-0">
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1="Invoice" parent2="Request URA Calculation" />
        <DisplaySuccessMessages successMessages={successMessages} />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              errorMessagesFromRedux?.length > 0
                ? _.map(errorMessagesFromRedux, (l) => l.message)
                : []
            ),
          ]}
        />
        {!fullScreenView && (
          <div className="panel mb-3">
            <div className="row">
              <div className="col-sm-12">
                <fieldset className="custom-fieldset">
                  <legend
                    className="same-font-family"
                    id="demo-row-radio-buttons-group-label"
                  >
                    Plan Type<span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="planType"
                            onChange={handleReqURACalcData}
                            value={reqURACalcData?.planType}
                            required
                          >
                            {/* <FormControlLabel
                              style={{ marginRight: "240px" }}
                              value="FD"
                              control={<Radio />}
                              label="Medicaid"
                              data-test="Medicaid"
                            /> */}
                            <FormControlLabel
                              style={{ marginRight: '240px' }}
                              value="COMM"
                              control={<Radio />}
                              label="Commercial"
                              data-test="Commercial"
                            />
                            <FormControlLabel
                              style={{ marginRight: '240px' }}
                              value="ST"
                              control={<Radio />}
                              label="State"
                              data-test="State"
                            />
                            <FormControlLabel
                              value="SUPP"
                              control={<Radio />}
                              label="Supplemental"
                              data-test="Supplemental"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <div className="mui-custom-form with-select input-md override-width-95 mandate-fields">
                  <TextField
                    label="Rebate Program"
                    fullWidth
                    select
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      id: 'rebateProgramCode',
                    }}
                    required
                    onChange={handleReqURACalcData}
                    id="rebateProgramCode"
                    name="rebateProgramCode"
                    value={reqURACalcData?.rebateProgramCode || '-1'}
                    className={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field === 'rebateProgramCode'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field === 'rebateProgramCode' ? l.message : null
                          )
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field === 'rebateProgramCode' ? l.message : null
                          )
                        : null
                    }
                    onBlur={(e) =>
                    {     setErrorMessages([]);
                      setSuccessMessages([])
                        handleOnblurEvent('rebateProgramCode', e.target.value)}
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramCodeURA?.length > 0
                      ? rebateProgramCodeURA.map((item) => {
                          return (
                            <MenuItem key={item.rpc} value={item.rpc}>
                              {item.rpc} {'|'} {item.shortDesc}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
              <div className="col-3">
                <div className="mui-custom-form input-md override-width-95">
                  <TextField
                    label="Quarter"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      maxLength: 6,
                    }}
                    required
                    id="quarter"
                    name="quarter"
                    value={reqURACalcData?.quarter}
                    onChange={handleReqURACalcData}
                    onBlur={(e) =>
                    {   setErrorMessages([])
                      setSuccessMessages([])
                       handleOnblurEvent('quarter', e.target?.value)}
                    }
                    className={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field === 'quarter' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    helperText={[
                      ...new Set(
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'quarter' ? l.message : null
                            )
                          : null
                      ),
                    ]}
                    error={[
                      ...new Set(
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'quarter' ? l.message : null
                            )
                          : null
                      ),
                    ]}
                  />
                </div>
              </div>
              <div className="col-2 mt-2">
                <div className="mui-custom-form with-select input-md mui-custom-form-with-margin2 ">
                  <div className="sub-radio text-black sub-label">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name="allManufacturers"
                          checked={reqURACalcData?.allManufacturers === 'Yes'}
                          onChange={(e) => {
                            handleReqURACalcData(e);
                            if (reqURACalcData?.allManufacturers === 'Yes') {
                              setErrorMessages([]);
                              setSuccessMessages([])
                              dispatch(dispatchManufacturersByPQR([]));
                              setSelected(null);
                              searchManufacturers();
                            }
                          }}
                        />
                      }
                      label="All Manufacturers"
                    />
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="btn-wrapper mt-4">
                  <div className="float-right mt-2 hide-on-print">
                    <Button
                      className="btn btn-success btn-save"
                      onClick={(e) => {
                        setErrorMessages([]);
                        setSuccessMessages([])
                        runURACalculation(e, 'N')}}
                      disabled={
                        reqURACalcData.allManufacturers === 'No' &&
                        selected == null
                      }
                    >
                      <SVGComponent iconName="Icon-run-now" /> Run Now
                    </Button>
                    <Button
                      className="btn btn-success btn-save"
                      onClick={(e) => {
                        setErrorMessages([]);
                        setSuccessMessages([])
                        runURACalculation(e, 'L')}}
                      disabled={
                        reqURACalcData.allManufacturers === 'No' &&
                        selected == null
                      }
                    >
                      <SVGComponent iconName="Icon-run-later" /> Run Later
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {reqURACalcData?.allManufacturers !== 'Yes' ? (
        <div className="panel tBillPanel-space pb-0">
          <div className="FRR-custom-table tbl-manufacturer-home">
            <Grid
              rowData={manufacturersByPQR?.data || []}
              columnDefs={manuFactureHead}
              onSelect={onCellClicked}
              gridHeight={fullScreenView ? '100vh' : 350}
              data-testid="onEditingStopped"
              rowSelection="multiple"
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              handleFullScreenViewClick={handleFullScreenView}
              exportFile
              fileName="Request URA Calculation"
              //handleViewHistory={handleViewHistory}
            />
          </div>
          {showViewHistory && (
            <ViewHistoryComponent
              setShowViewHistory={setShowViewHistory}
              tableName="CALCULATED_URA"
              keyValue={keyValue}
            />
          )}
        </div>
      ) : null}
    </div>
  );
}
export default withRouter(RequestURACalculation);
